<template>
  <div class="course_list flex FlexWrap FlexBetween">
    <div class="flex course_one flexcolumn FlexEvenly" v-for="(item, index) in courseRankList" :key="index">
      <div class="course_one_top">
        <el-image class="course_one_img" :src="imgPath(item.topBgImg)"></el-image>
        <div class="rank_name">{{ item.rankName }}</div>
      </div>
      <div class="course_rank_list flex-1 flex flexcolumn FlexWrap FlexAround">
        <div class="course_rank_one flex" v-for="(sitem, sindex) in item.rankList" :key="sindex">
          <div class="course_rank_one_rankValue" :class="[
            1 < sitem.rankValue && 3 >= sitem.rankValue
              ? 'course_rank_one_rankValue2'
              : 3 < sitem.rankValue && 5 >= sitem.rankValue
                ? 'course_rank_one_rankValue3'
                : '',
          ]">
            {{ sitem.rankValue }}
          </div>
          <div class="course_rank_one_right flex-1 flex cursor_pointer" @click="goCourseDetail(sitem)">
            <el-image class="course_one_img" :src="imgPath(sitem.courseCoverImg)"></el-image>
            <div class="flex flexcolumn FlexBetween course_info flex-1">
              <div class="toverflow course_name">{{ sitem.courseName }}</div>
              <div class="course_rate">
                <el-rate v-model="sitem.rate" disabled show-score text-color="#666666" score-template="{value}分" />
              </div>
              <div class="flex FlexBetween Flexalign course_online_info">
                <div class="course_price" v-if="sitem.saleMethod == 2">
                  <span class="course_price_unit">￥</span>{{ sitem.saleMethod == 2 ? sitem.coursePrice : 0 }}
                </div>
                <div class="course_price course_free" v-else>免费</div>
                <div class="course_online">
                  {{ sitem.courseExtra?.userNum }}人学习
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="course_rank_one flex flexcolumn FlexEvenly"
          v-for="(ssitem, ssindex) in (5 - item.rankList.length)" :key="ssindex"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "GjkcH5CourseRankList",

  data() {
    return {
      courseRankList: [
        {
          topBgImg: "range_bg1.png",
          rankName: "热门排行",
          rankList: [],
          orderByColumn: "hot_week",
        },
        {
          topBgImg: "range_bg2.png",
          rankName: "新课排行",
          rankList: [],
          orderByColumn: "hot_new_week",
        },
        {
          topBgImg: "range_bg3.png",
          rankName: "好评排行",
          rankList: [],
          orderByColumn: "good_appraise_week",
        },
      ],
      courseSelectedInfo: {
        shopId: "", // 商家Id
        courseName: "", // 课程名
        stageId: "", // 所属学段ID
        gradeId: "", // 所属年级ID
        subjectId: "", // 所属学科ID
        termId: "", // 所属学期ID
        publisherId: "", // 所属版本ID
        courseBookType: "", // 课程课本类型（1=课本课程，2=自定义课程）
        textbookId: "", // 所属教材ID
        courseDifficulty: "", // 课程难度
        learningStyle: "", // 学习方式（1=不限、2=闯关学习）
        saleMethod: "", // 售卖方式（1=免费，2=付费）
        pointsUsable: "", // 积分抵扣（1=允许，2=不允许）
        page: 1, // 页码
        pageSize: 5, // 单页数量
        isAsc: "desc", //升降序
        typeId: "", // 课程类型
      },
    };
  },
  computed: {
    ...mapState({
      selectCourseType: (state) => state.user.selectCourseType,
    }),
  },
  watch: {
    selectCourseType: {
      handler(value) {
        this.courseSelectedInfo.typeId = value;
        this.getCourseList();
      },
      deep: true,
      immediate: true,
    },
  },

  mounted() {
    this.getCourseList();
  },

  methods: {
    getCourseList() {
      this.courseRankList.forEach((item) => {
        this.courseSelectedInfo.orderByColumn = item.orderByColumn;
        this.$Api.course
          .getCourseList(this.courseSelectedInfo)
          .then((res) => {
            item.rankList = res.data.data.list.map((sitem, sindex) => ({
              ...sitem, // 保留原有属性
              rankValue: sindex + 1,
              rate: this.$Tools.scoreToStar(sitem.courseExtra?.appraiseScore),
            }));
          })
          .catch((err) => {
            // this.$Dialog.toast(err.data.message, { type: "error" });
            console.log(err);
          });
      });
    },
    // 详情
    goCourseDetail(info) {
      this.$Jump.href("/courseDetail", { courseId: info.courseId });
    },
  },
};
</script>

<style lang="scss" scoped>
.course_list {
  width: $pageMainWidth;

  .course_one {
    background: #ffffff;
    border-radius: 10px;
    width: 386px;
    height: 546px;
    margin-top: 20px;

    .course_one_top {
      width: 100%;
      height: 118px;
      position: relative;
      top: 0;

      .rank_name {
        position: absolute;
        font-weight: bold;
        font-size: 24px;
        color: #c07d32;
        top: 25px;
        left: 20px;
      }
    }

    .course_rank_list {
      padding: 11px;
      margin-top: -56px;

      .course_rank_one {
        width: 100%;
        min-height: 70px;

        // 鼠标移入整个 course_rank_one 时，改变 course_name 的颜色
        &:hover {
          .course_rank_one_right {
            .course_info {
              .course_name {
                color: #13d6aa;
              }
            }
          }
        }

        .course_rank_one_rankValue {
          font-family: DIN;
          font-weight: bold;
          font-size: 22px;
          color: #e6534d;
          font-style: italic;
        }

        .course_rank_one_rankValue2 {
          color: rgba(237, 112, 49, 1);
        }

        .course_rank_one_rankValue3 {
          color: rgba(175, 175, 175, 1);
        }

        .course_rank_one_right {
          margin-left: 11px;

          .course_one_img {
            width: 112px;
            height: 70px;
            border-radius: 10px;
          }

          .course_info {
            height: 70px;
            margin-left: 11px;

            .course_name {
              width: 200px;
              height: 30px;
              transition: color 0.2s ease; // 添加过渡效果，更平滑
            }

            .course_rate {
              :deep(.el-rate .el-rate__icon) {
                margin-right: 0;
              }

              :deep(.el-rate) {
                height: auto;
              }
            }

            .course_online_info {
              .course_online {
                font-size: 14px;
                color: #999999;
              }

              .course_price {
                color: #ff6619;
                font-size: 18px;
                font-weight: 600;

                .course_price_unit {
                  font-size: 16px;
                  font-weight: 400;
                }
              }

              .course_free {
                font-size: 16px;
                font-weight: 400;
              }
            }
          }
        }
      }
    }
  }
}
</style>